package se.mittpass.shared.translation

interface Dictionary {
    val appTitle: String
    val appSubtitle: String
    val appDesc: String
    
    // Cookie Banner
    val cookieNotice: String
    val readMorePolicy: String
    val decline: String
    val accept: String

    // Navigation
    val personalliggare: String
    val schemalagga: String
    val egenkontroll: String
    val priser: String
    val faq: String
    val login: String
    val getStarted: String
    val startFree30: String
    
    // Sections
    val allSmallPlaceNeeds: String
    val builtByOwner: String
    val ownerQuote: String
    val simpleTransparent: String
    val trialInfo: String
    val krPerUser: String
    val perUserMonth: String
    val exVatInfo: String
    val commonQuestions: String

    // Simulator
    val simRealtimeOps: String
    val simScheduleAndShifts: String
    val simActiveShiftsToday: String
    val simSkatteverketAuditProof: String
    val simFoodSafetyTitle: String
    val simHygieneRounds: String
    val simClickTabsToTest: String

    // Features Section
    val feature1Title: String
    val feature1Desc: String
    val feature2Title: String
    val feature2Desc: String
    val feature3Title: String
    val feature3Desc: String
    val feature4Title: String
    val feature4Desc: String

    // Quote & Stats Section
    val uspCafePizzeria: String
    val uspStaffRegister: String
    val uspNoHardware: String
    val uspFortnoxExport: String
    val uspPushNotifications: String

    val stat1Title: String
    val stat1Desc: String
    val stat2Title: String
    val stat2Desc: String
    val stat3Title: String
    val stat3Desc: String

    // Pricing Section
    val priceFeature1: String
    val priceFeature2: String
    val priceFeature3: String
    val priceFeature4: String
    val priceFeature5: String
    val priceFeature6: String
    val priceFeature7: String

    // How It Works
    val howItWorksTitle: String
    val howItWorksSub: String
    val timelineTabStaff: String
    val timelineTabHaccp: String
    val timelineStaffStep1Title: String
    val timelineStaffStep1Desc: String
    val timelineStaffStep2Title: String
    val timelineStaffStep2Desc: String
    val timelineStaffStep3Title: String
    val timelineStaffStep3Desc: String
    val timelineStaffStep4Title: String
    val timelineStaffStep4Desc: String
    val timelineHaccpStep1Title: String
    val timelineHaccpStep1Desc: String
    val timelineHaccpStep2Title: String
    val timelineHaccpStep2Desc: String
    val timelineHaccpStep3Title: String
    val timelineHaccpStep3Desc: String
    val timelineHaccpStep4Title: String
    val timelineHaccpStep4Desc: String

    // Showcase
    val showcaseTitle: String
    val showcaseSub: String
    val showcaseTabSchema: String
    val showcaseTabPersonal: String
    val showcaseTabLiggare: String
    val showcaseTabLoner: String
    val showcaseTabEgenkontroll: String
    val showcaseTabInspektion: String
    val showcaseTabSemester: String
    val showcaseTabFranvaro: String

    // FAQ Section
    val faq1Question: String
    val faq1Answer: String
    val faq2Question: String
    val faq2Answer: String
    val faq3Question: String
    val faq3Answer: String
    val faq4Question: String
    val faq4Answer: String
    val faq5Question: String
    val faq5Answer: String

    // Contact
    val contactUs: String
    val contactSub: String
    val contactSuccess: String
    val contactNamePlaceholder: String
    val contactEmailPlaceholder: String
    val contactMessagePlaceholder: String
    val contactFillAllFields: String
    val contactGenericError: String
    val contactSending: String
    val contactSendBtn: String

    // Footer
    val footerTagline: String
    val footerProduct: String
    val footerAllRights: String
    val footerPrivacy: String
    val footerTerms: String
    val footerDpa: String
    val footerDeleteAccount: String
    val footerSupport: String

    // Sign Up Section
    val signUpTitle: String
    val signUpSub: String
    val signUpSuccessTitle: String
    val signUpSuccessPrefix: String
    val signUpSuccessSuffix: String
    val fieldNameOrgName: String
    val fieldPlaceholderOrgName: String
    val fieldNameWorkplace: String
    val fieldPlaceholderWorkplace: String
    val fieldNameEmail: String
    val fieldPlaceholderEmail: String
    val fieldNamePassword: String
    val fieldPlaceholderPassword: String
    val signUpPasswordMinLen: String
    val signUpRegisterError: String
    val signUpCreatingAccount: String
    val signUpCreateAccountBtn: String
    val signUpAlreadyHaveAccount: String

    // Founder Note
    val founderNoteQuote: String
    val founderName: String
    val founderTitle: String

    // Analytics & Common
    val loading: String
    val close: String
    val noData: String

    // KPI Cards
    val kpiStaff: String
    val kpiCheckedIn: String
    val kpiWorkedHours: String
    val kpiApprovedPayroll: String
    val kpiShiftsThisWeek: String
    val kpiUnclaimedShifts: String
    val kpiAbsencesToReview: String
    val kpiActiveAbsences: String

    // Daily hours chart
    val chartWorkedHoursTitle: String

    // Modals
    val modalStaffTitle: String
    val modalStaffSub: String
    val modalCheckedInTitle: String
    val modalCheckedInSub: String
    val modalWorkedTitle: String
    val modalWorkedSub: String
    val modalPayrollTitle: String
    val modalPayrollSub: String
    val modalShiftsTitle: String
    val modalShiftsSub: String
    val modalUnclaimedTitle: String
    val modalUnclaimedSub: String
    val modalPendingAbsenceTitle: String
    val modalPendingAbsenceSub: String
    val modalActiveAbsenceTitle: String
    val modalActiveAbsenceSub: String

    // Status / Roles
    val roleManager: String
    val roleStaff: String
    val statusCheckedInSince: String
    val statusClaimed: String
    val statusUnclaimed: String
    val statusPending: String

    // Empty States
    val emptyCheckedIn: String
    val emptyWorked: String
    val emptyPayroll: String
    val emptyShifts: String
    val emptyUnclaimed: String
    val emptyPendingAbsence: String
    val emptyActiveAbsence: String

    // Absence Types
    val absTypeSick: String
    val absTypeVab: String
    val absTypeVacation: String
    val absTypeLeave: String

    // Day Names Short
    val dayMon: String
    val dayTue: String
    val dayWed: String
    val dayThu: String
    val dayFri: String
    val daySat: String
    val daySun: String

    // New common fields/buttons for Login/SignUp/etc.
    val back: String
    val email: String
    val password: String
    val loggingIn: String
    val dontHaveAccount: String
    val alreadyHaveAccount: String
    val register: String
    val registerManagerSub: String
    val organization: String
    val workplace: String
    val min8Chars: String
    val registerFailedEmailUsed: String
    
    // SignUp terms agreement
    val signUpTermsPrefix: String
    val signUpTermsLink: String
    val signUpTermsMiddle: String
    val signUpTermsDpaLink: String
    val signUpTermsSuffix: String

    // Simulator Details
    val simTabHrEyebrow: String
    val simTabHrHeadline1: String
    val simTabHrHeadline2: String
    val simTabHrSubhead: String

    val simTabLiggareEyebrow: String
    val simTabLiggareHeadline1: String
    val simTabLiggareHeadline2: String
    val simTabLiggareSubhead: String

    val simTabHaccpEyebrow: String
    val simTabHaccpHeadline1: String
    val simTabHaccpHeadline2: String
    val simTabHaccpSubhead: String

    val simTabDefaultEyebrow: String
    val simTabDefaultHeadline1: String
    val simTabDefaultHeadline2: String
    val simTabDefaultSubhead: String

    val simRoleServering: String
    val simRoleKok: String
    val simDagensSchema: String
    val simExtraStaffAddedText: String
    val simResetBtn: String
    val simInviteStaffBtn: String
    val simSkatteverketLiggare: String
    val simCheckedInStatus: String
    val simNotCheckedInStatus: String
    val simCheckedInDesc: String
    val simNotCheckedInDesc: String
    val simCheckOutBtn: String
    val simCheckInBtn: String
    val simHaccpTitle: String
    val simKyl1Name: String
    val simFrysName: String
    val simAllTempsOk: String
    val simTempsWarning: String

    // Footer links
    val footerFunktioner: String
    val footerPriser: String
    val footerFaq: String
    val footerKontakt: String
    val footerEmail: String

    // Showcase subtabs
    val showcaseSubTabWeek: String
    val showcaseSubTabMonth: String
    val showcaseSubTabYear: String
    val showcaseSubTabFlow: String
}

object SwedishDictionary : Dictionary {
    override val appTitle = "Mittpass – Din arbetsplats"
    override val appSubtitle = "Mittpass – Schema & personalliggare för café och restaurang"
    override val appDesc = "Personalhantering för café, pizzeria och restaurang. Elektronisk personalliggare, schemaläggning och egenkontroll."
    
    override val cookieNotice = "Vi använder cookies för att förstå hur besökare använder webbplatsen (Google Analytics). Inga cookies används för reklam."
    override val readMorePolicy = "Läs mer i vår integritetspolicy"
    override val decline = "Avböj"
    override val accept = "Acceptera"
    
    override val personalliggare = "Personalliggare"
    override val schemalagga = "Schemaläggning"
    override val egenkontroll = "Egenkontroll"
    override val priser = "Priser"
    override val faq = "FAQ"
    override val login = "Logga in"
    override val getStarted = "Kom igång"
    override val startFree30 = "Starta 30 dagar gratis"
    
    override val allSmallPlaceNeeds = "Allt ett litet ställe behöver"
    override val builtByOwner = "Byggt av en caféägare – för caféer, pizzerior och restauranger"
    override val ownerQuote = "Jag saknade ett system som passade mitt café – inte ett Enterprise-verktyg anpassat för kedjor. Mittpass är det jag ville ha: enkelt nog att alla i personalen lär sig det på fem minuter, och komplett nog att sköta allt från schema till löneunderlag."
    override val simpleTransparent = "Enkelt och transparent"
    override val trialInfo = "30 dagar gratis — inget kreditkort behövs"
    override val krPerUser = "39 kr"
    override val perUserMonth = "/ aktiv användare / månad"
    override val exVatInfo = "Exkl. moms. Inaktiva användare alltid gratis."
    override val commonQuestions = "Vanliga frågor"

    // Simulator
    override val simRealtimeOps = "Verksamhet i Realtid"
    override val simScheduleAndShifts = "Schema & Pass"
    override val simActiveShiftsToday = "3 aktiva pass idag"
    override val simSkatteverketAuditProof = "Skatteverket revisionssäker"
    override val simFoodSafetyTitle = "Livsmedelskontroll"
    override val simHygieneRounds = "Hygienronder & temperaturer"
    override val simClickTabsToTest = "Klicka på flikarna för att testa funktionerna"

    // Features Section
    override val feature1Title = "Schema & incheckningar"
    override val feature1Desc = "Lägg pass på minuter. Personal checkar in direkt i appen – du ser vem som är på plats i realtid."
    override val feature2Title = "Personalliggare"
    override val feature2Desc = "Skatteverkets krav uppfyllt automatiskt. Dagsvy, snapshot och CSV-export för revision och bokföring."
    override val feature3Title = "Löneunderlag"
    override val feature3Desc = "Godkänn arbetade timmar och få färdiga löneunderlag. Slipp räkna timmar manuellt i slutet av månaden."
    override val feature4Title = "Push-notiser"
    override val feature4Desc = "Öppna pass notifieras direkt i personalens mobil. En knapptryckning för att ta passet – inga samtal behövs."

    // Quote & Stats Section
    override val uspCafePizzeria = "Café & pizzeria"
    override val uspStaffRegister = "Elektronisk personalliggare"
    override val uspNoHardware = "Ingen hårdvara"
    override val uspFortnoxExport = "Färdigt löneunderlag"
    override val uspPushNotifications = "Push-notiser"

    override val stat1Title = "1 app"
    override val stat1Desc = "Schema, personalliggare & löneunderlag – samlat på ett ställe"
    override val stat2Title = "0 kr"
    override val stat2Desc = "I startavgift eller bindningstid – prova 30 dagar gratis"
    override val stat3Title = "100%"
    override val stat3Desc = "Lagkrav uppfyllda – personalliggare & HACCP-egenkontroll"

    // Pricing Section
    override val priceFeature1 = "Schema & incheckningar i realtid"
    override val priceFeature2 = "Elektronisk personalliggare (Skatteverket)"
    override val priceFeature3 = "Löneunderlag med godkännande och CSV-export"
    override val priceFeature4 = "Push-notiser för lediga pass"
    override val priceFeature5 = "Frånvaro- och övertidshantering"
    override val priceFeature6 = "Inaktiva användare är alltid gratis"
    override val priceFeature7 = "Ingen startavgift · Ingen bindningstid"

    // How It Works
    override val howItWorksTitle = "Så fungerar Mittpass"
    override val howItWorksSub = "Från schemaläggning till godkänt underlag – i fyra enkla steg."
    override val timelineTabStaff = "Personal & Schema"
    override val timelineTabHaccp = "Livsmedelskontroll"
    override val timelineStaffStep1Title = "Skapa schema"
    override val timelineStaffStep1Desc = "Bygg veckoschemat och publicera med ett klick."
    override val timelineStaffStep2Title = "Personalen stämplar"
    override val timelineStaffStep2Desc = "In- och utcheckning direkt i appen vid arbetspassets början och slut."
    override val timelineStaffStep3Title = "Liggaren uppdateras"
    override val timelineStaffStep3Desc = "Skatteverket-kompatibel personalliggare förs automatiskt i bakgrunden."
    override val timelineStaffStep4Title = "Löneunderlag klart"
    override val timelineStaffStep4Desc = "Godkänn timmarna vid månadsslut och ladda ned färdigt löneunderlag."

    override val timelineHaccpStep1Title = "Skapa rutiner"
    override val timelineHaccpStep1Desc = "Ställ in återkommande kontroller för kyl, frys, varmhållning och städning."
    override val timelineHaccpStep2Title = "Personalen loggar"
    override val timelineHaccpStep2Desc = "Temperaturer och hygienronder prickas av snabbt i mobilen under arbetsdagen."
    override val timelineHaccpStep3Title = "Automatiska larm"
    override val timelineHaccpStep3Desc = "Få notiser direkt om en temperatur avviker från godkända gränsvärden."
    override val timelineHaccpStep4Title = "Inspektionsrapport"
    override val timelineHaccpStep4Desc = "Visa fullständig historik med en knapptryckning vid miljöinspektion."

    // Showcase
    override val showcaseTitle = "Se hur enkelt det är"
    override val showcaseSub = "Ett modernt gränssnitt byggt för fart, enkelhet och precision."
    override val showcaseTabSchema = "Schema"
    override val showcaseTabPersonal = "Personal"
    override val showcaseTabLiggare = "Liggare"
    override val showcaseTabLoner = "Löner"
    override val showcaseTabEgenkontroll = "Egenkontroll"
    override val showcaseTabInspektion = "Inspektionsrapport"
    override val showcaseTabSemester = "Semester"
    override val showcaseTabFranvaro = "Frånvaro"

    // FAQ Section
    override val faq1Question = "Passar Mittpass mitt lilla café eller pizzeria?"
    override val faq1Answer = "Ja – det är precis för dig det är byggt. Mittpass is designat för ställen med 2–20 anställda. Inga onödiga funktioner, inga långa onboardingar. Du är igång på en dag."
    override val faq2Question = "Vad är personalliggare och måste jag ha det?"
    override val faq2Answer = "Ja, Skatteverket kräver att restauranger och caféer för elektronisk personalliggare. Mittpass sköter det automatiskt – du slipper papper och manuella listor."
    override val faq3Question = "Hur fungerar löneunderlaget?"
    override val faq3Answer = "Personal checkar in och ut via appen. I slutet av månaden godkänner du timmarna och laddar ned färdigt underlag som CSV. Klart."
    override val faq4Question = "Behöver jag köpa hårdvara?"
    override val faq4Answer = "Nej. Personal och chefer använder sina egna smartphones. Ingen tablet, ingen klocka, inget att installera på plats."
    override val faq5Question = "Kan jag prova innan jag beställer?"
    override val faq5Answer = "Ja. Du får 30 dagars gratis provperiod utan att ange kortuppgifter. Testa alla funktioner fullt ut – och välj sedan om du vill fortsätta."

    // Contact
    override val contactUs = "Kontakta oss"
    override val contactSub = "Frågor, feedback eller teknisk support — vi svarar inom en arbetsdag."
    override val contactSuccess = "✓ Tack! Vi återkommer så snart vi kan."
    override val contactNamePlaceholder = "Ditt namn"
    override val contactEmailPlaceholder = "Din e-postadress"
    override val contactMessagePlaceholder = "Ditt meddelande…"
    override val contactFillAllFields = "Fyll i alla fält."
    override val contactGenericError = "Något gick fel. Försök igen eller mejla oss direkt."
    override val contactSending = "Skickar…"
    override val contactSendBtn = "Skicka meddelande"

    // Footer
    override val footerTagline = "Mittpass är en produkt av Brave Consulting AB (org.nr 5592910318) – personal- och drifthantering för verksamheter med timanställda."
    override val footerProduct = "Produkt"
    override val footerAllRights = "© Mittpass · Brave Consulting AB (559291-0318). Alla rättigheter förbehållna."
    override val footerPrivacy = "Integritetspolicy"
    override val footerTerms = "Användarvillkor"
    override val footerDpa = "Personuppgiftsbiträdesavtal"
    override val footerDeleteAccount = "Radera konto & data"
    override val footerSupport = "Support & Hjälp"

    // Sign Up Section
    override val signUpTitle = "Kom igång på 30 sekunder"
    override val signUpSub = "Skapa ett konto gratis och testa alla funktioner i 30 dagar. Inget kreditkort, ingen bindningstid."
    override val signUpSuccessTitle = "Kolla din e-post!"
    override val signUpSuccessPrefix = "Vi har skickat ett verifieringsmail till "
    override val signUpSuccessSuffix = ". Klicka på länken för att aktivera ditt konto."
    override val fieldNameOrgName = "Företagsnamn"
    override val fieldPlaceholderOrgName = "Din organisation AB"
    override val fieldNameWorkplace = "Arbetsplats"
    override val fieldPlaceholderWorkplace = "T.ex. Restaurang Centrum"
    override val fieldNameEmail = "E-post"
    override val fieldPlaceholderEmail = "din@email.se"
    override val fieldNamePassword = "Lösenord"
    override val fieldPlaceholderPassword = "Minst 8 tecken"
    override val signUpPasswordMinLen = "Lösenordet måste vara minst 8 tecken."
    override val signUpRegisterError = "Registrering misslyckades."
    override val signUpCreatingAccount = "Skapar konto…"
    override val signUpCreateAccountBtn = "Skapa konto gratis"
    override val signUpAlreadyHaveAccount = "Har du redan ett konto? Logga in via knappen högst upp på sidan."

    // Founder Note
    override val founderNoteQuote = "Jag ägde ett café och tröttnade på Excel-scheman, handskrivna personalliggare och att ringa runt efter personal. Jag byggde Mittpass för att lösa mina egna problem – och nu använder vi det varje dag."
    override val founderName = "Henric"
    override val founderTitle = "Grundare, Mittpass • tidigare caféägare"

    // Analytics & Common
    override val loading = "Laddar…"
    override val close = "Stäng"
    override val noData = "Ingen data."

    // KPI Cards
    override val kpiStaff = "Personal"
    override val kpiCheckedIn = "Incheckade nu"
    override val kpiWorkedHours = "Arbetade timmar (30d)"
    override val kpiApprovedPayroll = "Godkända lönetimmar"
    override val kpiShiftsThisWeek = "Pass denna vecka"
    override val kpiUnclaimedShifts = "Otagna pass"
    override val kpiAbsencesToReview = "Frånvaro att granska"
    override val kpiActiveAbsences = "Aktiva frånvaror idag"

    // Daily hours chart
    override val chartWorkedHoursTitle = "Arbetade timmar per dag (senaste 14 dagar)"

    // Modals
    override val modalStaffTitle = "Personal"
    override val modalStaffSub = "personer"
    override val modalCheckedInTitle = "Incheckade just nu"
    override val modalCheckedInSub = "personer"
    override val modalWorkedTitle = "Arbetade timmar (30 dagar)"
    override val modalWorkedSub = "totalt"
    override val modalPayrollTitle = "Godkända lönetimmar (30 dagar)"
    override val modalPayrollSub = "totalt"
    override val modalShiftsTitle = "Pass denna vecka"
    override val modalShiftsSub = "pass"
    override val modalUnclaimedTitle = "Otagna pass denna vecka"
    override val modalUnclaimedSub = "pass utan personal"
    override val modalPendingAbsenceTitle = "Frånvaro att granska"
    override val modalPendingAbsenceSub = "ansökningar väntar"
    override val modalActiveAbsenceTitle = "Aktiva frånvaror idag"
    override val modalActiveAbsenceSub = "personer frånvarande"

    // Status / Roles
    override val roleManager = "Chef"
    override val roleStaff = "Personal"
    override val statusCheckedInSince = "Sedan"
    override val statusClaimed = "Tagen"
    override val statusUnclaimed = "Ledig"
    override val statusPending = "Väntar"

    // Empty States
    override val emptyCheckedIn = "Ingen är incheckad just nu."
    override val emptyWorked = "Ingen data för senaste 30 dagarna."
    override val emptyPayroll = "Inga godkända lönetimmar."
    override val emptyShifts = "Inga pass denna vecka."
    override val emptyUnclaimed = "Alla pass är tagna!"
    override val emptyPendingAbsence = "Inga frånvaroansökningar att granska."
    override val emptyActiveAbsence = "Inga aktiva frånvaror idag."

    // Absence Types
    override val absTypeSick = "Sjuk"
    override val absTypeVab = "VAB"
    override val absTypeVacation = "Semester"
    override val absTypeLeave = "Tjänstledig"

    override val dayMon = "Mån"
    override val dayTue = "Tis"
    override val dayWed = "Ons"
    override val dayThu = "Tor"
    override val dayFri = "Fre"
    override val daySat = "Lör"
    override val daySun = "Sön"

    override val back = "Tillbaka"
    override val email = "E-post"
    override val password = "Lösenord"
    override val loggingIn = "Loggar in…"
    override val dontHaveAccount = "Har du inget konto?"
    override val alreadyHaveAccount = "Har du redan ett konto?"
    override val register = "Registrera dig"
    override val registerManagerSub = "Registrera dig som chef för en ny organisation"
    override val organization = "Organisation"
    override val workplace = "Arbetsplats"
    override val min8Chars = "Minst 8 tecken"
    override val registerFailedEmailUsed = "Kunde inte skapa konto. E-postadressen kan redan användas."

    override val signUpTermsPrefix = "Genom att registrera dig godkänner du våra "
    override val signUpTermsLink = "användarvillkor"
    override val signUpTermsMiddle = " och ingår ett "
    override val signUpTermsDpaLink = "personuppgiftsbiträdesavtal"
    override val signUpTermsSuffix = " med Mittpass."

    override val simTabHrEyebrow = "Personalhantering"
    override val simTabHrHeadline1 = "Skapa scheman och hantera tidrapportering "
    override val simTabHrHeadline2 = "blixtsnabbt."
    override val simTabHrSubhead = "Släpp Excel och pappersscheman. Planera pass, hantera frånvaro och få färdiga löneunderlag med ett enkelt klick."

    override val simTabLiggareEyebrow = "Personalliggare"
    override val simTabLiggareHeadline1 = "Elektronisk personalliggare "
    override val simTabLiggareHeadline2 = "helt utan krångel."
    override val simTabLiggareSubhead = "Möt lagkraven säkert. Personalen checkar in och ut i mobilen på sekunder. Generera revisionssäkra rapporter för Skatteverkets kontroller direkt."

    override val simTabHaccpEyebrow = "Livsmedelskontroll"
    override val simTabHaccpHeadline1 = "Digital livsmedelskontroll och "
    override val simTabHaccpHeadline2 = "egenkontroll (HACCP)."
    override val simTabHaccpSubhead = "Slipp handskrivna checklistor och pärmar. Logga temperaturer, utför hygienronder och spara allt molnbaserat – redo för miljöinspektören."

    override val simTabDefaultEyebrow = "Café · Pizzeria · Restaurang"
    override val simTabDefaultHeadline1 = "Styr schema, personalliggare och livsmedelskontroll "
    override val simTabDefaultHeadline2 = "utan pappersarbete."
    override val simTabDefaultSubhead = "Mittpass är byggt av en caféägare för caféägare. Lägg schema, kolla in personal, uppfyll lagkrav och logga temperaturer – allt från mobilen."

    override val simRoleServering = "Servering"
    override val simRoleKok = "Kök"
    override val simDagensSchema = "Dagens Schema"
    override val simExtraStaffAddedText = "Extra pass publicerat till personalen!"
    override val simResetBtn = "Återställ simulator"
    override val simInviteStaffBtn = "+ Bjud in extra personal"
    override val simSkatteverketLiggare = "Skatteverkets Personalliggare"
    override val simCheckedInStatus = "INCHECKAD: Johan Berg"
    override val simNotCheckedInStatus = "INTE INCHECKAD"
    override val simCheckedInDesc = "Incheckad kl: 14:15. Loggen är revisionssäker."
    override val simNotCheckedInDesc = "Klicka på knappen nedan för att checka in i personalens vy."
    override val simCheckOutBtn = "Checka ut"
    override val simCheckInBtn = "Checka in"
    override val simHaccpTitle = "Egenkontroll (HACCP)"
    override val simKyl1Name = "Kyl 1 (Dryck)"
    override val simFrysName = "Frys (Kök)"
    override val simAllTempsOk = "✓ Alla temperaturer godkända!"
    override val simTempsWarning = "Vissa temperaturer utanför gränsvärden!"

    override val footerFunktioner = "Funktioner"
    override val footerPriser = "Priser"
    override val footerFaq = "FAQ"
    override val footerKontakt = "Kontakt"
    override val footerEmail = "E-post"

    override val showcaseSubTabWeek = "Vecka"
    override val showcaseSubTabMonth = "Månad"
    override val showcaseSubTabYear = "År"
    override val showcaseSubTabFlow = "Flöde"
}

object EnglishDictionary : Dictionary {
    override val appTitle = "Mittpass – Your Workplace"
    override val appSubtitle = "Mittpass – Schedule & staff register for cafe and restaurant"
    override val appDesc = "Staff management for cafe, pizzeria, and restaurant. Electronic staff register, scheduling, and self-monitoring."
    
    override val cookieNotice = "We use cookies to understand how visitors use the website (Google Analytics). No advertising cookies are used."
    override val readMorePolicy = "Read more in our privacy policy"
    override val decline = "Decline"
    override val accept = "Accept"
    
    override val personalliggare = "Staff Register"
    override val schemalagga = "Scheduling"
    override val egenkontroll = "Self-monitoring"
    override val priser = "Pricing"
    override val faq = "FAQ"
    override val login = "Log in"
    override val getStarted = "Get Started"
    override val startFree30 = "Start 30 days free"
    
    override val allSmallPlaceNeeds = "Everything a small place needs"
    override val builtByOwner = "Built by a cafe owner – for cafes, pizzerias, and restaurants"
    override val ownerQuote = SwedishDictionary.ownerQuote
    override val simpleTransparent = "Simple and transparent"
    override val trialInfo = "30 days free — no credit card required"
    override val krPerUser = "39 SEK"
    override val perUserMonth = "/ active user / month"
    override val exVatInfo = "Excl. VAT. Inactive users always free."
    override val commonQuestions = "Frequently Asked Questions"

    // Simulator
    override val simRealtimeOps = "Real-time Operations"
    override val simScheduleAndShifts = "Schedule & Shifts"
    override val simActiveShiftsToday = "3 active shifts today"
    override val simSkatteverketAuditProof = "Skatteverket audit proof"
    override val simFoodSafetyTitle = "Food Safety"
    override val simHygieneRounds = "Hygiene rounds & temperatures"
    override val simClickTabsToTest = "Click on the tabs to test the functions"

    // Features Section
    override val feature1Title = "Schedule & check-ins"
    override val feature1Desc = "Create shifts in minutes. Staff check in directly in the app – see who's on site in real time."
    override val feature2Title = "Staff Register"
    override val feature2Desc = "Skatteverket requirements met automatically. Daily view, snapshot, and CSV export for audit."
    override val feature3Title = "Payroll Reports"
    override val feature3Desc = "Approve worked hours and export directly to Fortnox. No more manual hour calculations."
    override val feature4Title = "Push Notifications"
    override val feature4Desc = "Open shifts notified directly on staff phones. One tap to claim a shift – no calls needed."

    // Quote & Stats Section
    override val uspCafePizzeria = "Cafe & pizzeria"
    override val uspStaffRegister = "Electronic staff register"
    override val uspNoHardware = "No hardware"
    override val uspFortnoxExport = "Fortnox export"
    override val uspPushNotifications = "Push notifications"

    override val stat1Title = "1 app"
    override val stat1Desc = "Schedule, staff register & payroll – all in one place"
    override val stat2Title = "0 SEK"
    override val stat2Desc = "Startup fee or commitment period – try 30 days free"
    override val stat3Title = "100%"
    override val stat3Desc = "Legal requirements met – staff register & HACCP self-monitoring"

    // Pricing Section
    override val priceFeature1 = "Real-time schedule & check-ins"
    override val priceFeature2 = "Electronic staff register (Skatteverket)"
    override val priceFeature3 = "Payroll reports with approval and Fortnox export"
    override val priceFeature4 = "Push notifications for open shifts"
    override val priceFeature5 = "Absence and overtime management"
    override val priceFeature6 = "Inactive users are always free"
    override val priceFeature7 = "No startup fee · No commitment period"

    // How It Works
    override val howItWorksTitle = "How Mittpass Works"
    override val howItWorksSub = "Simplify daily operations with digital flows for both staff planning and food safety."
    override val timelineTabStaff = "Staff & Payroll"
    override val timelineTabHaccp = "Self-monitoring (HACCP)"
    override val timelineStaffStep1Title = "1. Plan the schedule"
    override val timelineStaffStep1Desc = "Create and publish shifts in seconds. Instantly see who is available and avoid scheduling conflicts."
    override val timelineStaffStep2Title = "2. Fill shifts instantly"
    override val timelineStaffStep2Desc = "Staff get push notifications and can book themselves with one tap. No phone calls or late-night SMS threads."
    override val timelineStaffStep3Title = "3. Automatic check-in"
    override val timelineStaffStep3Desc = "Staff clock in and out directly in the app at the workplace. The system tracks hours down to the second."
    override val timelineStaffStep4Title = "4. Payroll & Staff Register"
    override val timelineStaffStep4Desc = "Get ready-to-use payroll documents approved and done. Simultaneously satisfies all Skatteverket staff register rules."
    override val timelineHaccpStep1Title = "1. Define tasks"
    override val timelineHaccpStep1Desc = "Create checklists for cleaning, temperatures, and self-monitoring directly in the system."
    override val timelineHaccpStep2Title = "2. Execute in the app"
    override val timelineHaccpStep2Desc = "Staff tick off tasks and log temperatures in their mobile phones during the shift."
    override val timelineHaccpStep3Title = "3. Get alerts instantly"
    override val timelineHaccpStep3Desc = "If a fridge gets too warm or a cleaning routine is missed, you get notified immediately."
    override val timelineHaccpStep4Title = "4. Inspection report"
    override val timelineHaccpStep4Desc = "Export complete, timestamped reports during health department inspections."

    // Showcase
    override val showcaseTitle = "See the system in action"
    override val showcaseSub = "Everything you need to run your cafe or restaurant – in one single system."
    override val showcaseTabSchema = "Schedule"
    override val showcaseTabPersonal = "Staff"
    override val showcaseTabLiggare = "Staff Register"
    override val showcaseTabLoner = "Payroll"
    override val showcaseTabEgenkontroll = "Self-monitoring"
    override val showcaseTabInspektion = "Inspection Report"
    override val showcaseTabSemester = "Vacation"
    override val showcaseTabFranvaro = "Leave & Absence"

    // FAQ Section
    override val faq1Question = "Does Mittpass fit my small cafe or pizzeria?"
    override val faq1Answer = "Yes – that's exactly who it is built for. Mittpass is designed for venues with 2–20 employees. No unnecessary features, no long onboardings. Get started in one day."
    override val faq2Question = "What is a staff register and do I need one?"
    override val faq2Answer = "Yes, Skatteverket requires restaurants and cafes to maintain an electronic staff register. Mittpass handles it automatically – no paper or manual lists."
    override val faq3Question = "How does the payroll reporting work?"
    override val faq3Answer = "Staff check in and out via the app. At the end of the month, you approve the hours and export directly to Fortnox or download as CSV. Done."
    override val faq4Question = "Do I need to buy hardware?"
    override val faq4Answer = "No. Staff and managers use their own smartphones. No tablet, no clock, nothing to install on-site."
    override val faq5Question = "Can I try before I order?"
    override val faq5Answer = "Yes. You get a 30-day free trial period without entering card details. Test all features fully – and then decide if you want to continue."

    // Contact
    override val contactUs = "Contact Us"
    override val contactSub = "Questions, feedback, or technical support — we reply within one business day."
    override val contactSuccess = "✓ Thank you! We will get back to you as soon as possible."
    override val contactNamePlaceholder = "Your name"
    override val contactEmailPlaceholder = "Your email address"
    override val contactMessagePlaceholder = "Your message..."
    override val contactFillAllFields = "Please fill in all fields."
    override val contactGenericError = "Something went wrong. Please try again or email us directly."
    override val contactSending = "Sending..."
    override val contactSendBtn = "Send Message"

    // Footer
    override val footerTagline = "Mittpass is a product by Brave Consulting AB (org. no. 559291-0318) – operations and shift planning for businesses with hourly staff."
    override val footerProduct = "Product"
    override val footerAllRights = "© Mittpass · Brave Consulting AB (559291-0318). All rights reserved."
    override val footerPrivacy = "Privacy Policy"
    override val footerTerms = "Terms of Service"
    override val footerDpa = "Data Processing Agreement"
    override val footerDeleteAccount = "Delete Account & Data"
    override val footerSupport = "Support & Help"

    // Sign Up Section
    override val signUpTitle = "Get started in 30 seconds"
    override val signUpSub = "Create an account for free and test all features for 30 days. No credit card, no commitment period."
    override val signUpSuccessTitle = "Check your email!"
    override val signUpSuccessPrefix = "We have sent a verification email to "
    override val signUpSuccessSuffix = ". Click the link to activate your account."
    override val fieldNameOrgName = "Company Name"
    override val fieldPlaceholderOrgName = "Your Organisation AB"
    override val fieldNameWorkplace = "Workplace"
    override val fieldPlaceholderWorkplace = "E.g. Restaurant Center"
    override val fieldNameEmail = "Email"
    override val fieldPlaceholderEmail = "you@email.com"
    override val fieldNamePassword = "Password"
    override val fieldPlaceholderPassword = "At least 8 characters"
    override val signUpPasswordMinLen = "Password must be at least 8 characters."
    override val signUpRegisterError = "Registration failed."
    override val signUpCreatingAccount = "Creating account..."
    override val signUpCreateAccountBtn = "Create Free Account"
    override val signUpAlreadyHaveAccount = "Already have an account? Log in using the button at the top of the page."

    // Founder Note
    override val founderNoteQuote = SwedishDictionary.founderNoteQuote
    override val founderName = SwedishDictionary.founderName
    override val founderTitle = SwedishDictionary.founderTitle

    // Analytics & Common
    override val loading = "Loading..."
    override val close = "Close"
    override val noData = "No data."

    // KPI Cards
    override val kpiStaff = "Staff"
    override val kpiCheckedIn = "Checked in now"
    override val kpiWorkedHours = "Worked hours (30d)"
    override val kpiApprovedPayroll = "Approved payroll hours"
    override val kpiShiftsThisWeek = "Shifts this week"
    override val kpiUnclaimedShifts = "Unclaimed shifts"
    override val kpiAbsencesToReview = "Absences to review"
    override val kpiActiveAbsences = "Active absences today"

    // Daily hours chart
    override val chartWorkedHoursTitle = "Worked hours per day (last 14 days)"

    // Modals
    override val modalStaffTitle = "Staff"
    override val modalStaffSub = "people"
    override val modalCheckedInTitle = "Checked in right now"
    override val modalCheckedInSub = "people"
    override val modalWorkedTitle = "Worked hours (30 days)"
    override val modalWorkedSub = "total"
    override val modalPayrollTitle = "Approved payroll hours (30 days)"
    override val modalPayrollSub = "total"
    override val modalShiftsTitle = "Shifts this week"
    override val modalShiftsSub = "shifts"
    override val modalUnclaimedTitle = "Unclaimed shifts this week"
    override val modalUnclaimedSub = "shifts without staff"
    override val modalPendingAbsenceTitle = "Absences to review"
    override val modalPendingAbsenceSub = "applications pending"
    override val modalActiveAbsenceTitle = "Active absences today"
    override val modalActiveAbsenceSub = "people absent"

    // Status / Roles
    override val roleManager = "Manager"
    override val roleStaff = "Staff"
    override val statusCheckedInSince = "Since"
    override val statusClaimed = "Claimed"
    override val statusUnclaimed = "Vacant"
    override val statusPending = "Pending"

    // Empty States
    override val emptyCheckedIn = "No one is checked in right now."
    override val emptyWorked = "No data for the last 30 days."
    override val emptyPayroll = "No approved payroll hours."
    override val emptyShifts = "No shifts this week."
    override val emptyUnclaimed = "All shifts are claimed!"
    override val emptyPendingAbsence = "No absence applications to review."
    override val emptyActiveAbsence = "No active absences today."

    // Absence Types
    override val absTypeSick = "Sick"
    override val absTypeVab = "VAB (Care of child)"
    override val absTypeVacation = "Vacation"
    override val absTypeLeave = "Leave of absence"

    override val dayMon = "Mon"
    override val dayTue = "Tue"
    override val dayWed = "Wed"
    override val dayThu = "Thu"
    override val dayFri = "Fri"
    override val daySat = "Sat"
    override val daySun = "Sun"

    override val back = "Back"
    override val email = "Email"
    override val password = "Password"
    override val loggingIn = "Logging in…"
    override val dontHaveAccount = "Don't have an account?"
    override val alreadyHaveAccount = "Already have an account?"
    override val register = "Register"
    override val registerManagerSub = "Register as manager for a new organization"
    override val organization = "Organization"
    override val workplace = "Workplace"
    override val min8Chars = "At least 8 characters"
    override val registerFailedEmailUsed = "Could not create account. The email address might already be in use."

    override val signUpTermsPrefix = "By registering, you agree to our "
    override val signUpTermsLink = "Terms of Service"
    override val signUpTermsMiddle = " and enter into a "
    override val signUpTermsDpaLink = "Data Processing Agreement"
    override val signUpTermsSuffix = " with Mittpass."

    override val simTabHrEyebrow = "Staff Management"
    override val simTabHrHeadline1 = "Create schedules and manage time reports "
    override val simTabHrHeadline2 = "lightning fast."
    override val simTabHrSubhead = "Ditch Excel and paper schedules. Plan shifts, manage leave, and send ready payroll reports to Fortnox with a simple click."

    override val simTabLiggareEyebrow = "Staff Register"
    override val simTabLiggareHeadline1 = "Electronic staff register "
    override val simTabLiggareHeadline2 = "completely hassle-free."
    override val simTabLiggareSubhead = "Meet legal requirements safely. Staff check in and out on their phones in seconds. Generate audit-proof reports for Skatteverket audits instantly."

    override val simTabHaccpEyebrow = "Food Safety"
    override val simTabHaccpHeadline1 = "Digital food safety and "
    override val simTabHaccpHeadline2 = "self-monitoring (HACCP)."
    override val simTabHaccpSubhead = "Avoid handwritten checklists and binders. Log temperatures, perform hygiene rounds, and save everything in the cloud – ready for the inspector."

    override val simTabDefaultEyebrow = "Cafe · Pizzeria · Restaurant"
    override val simTabDefaultHeadline1 = "Manage schedules, staff registers, and food safety "
    override val simTabDefaultHeadline2 = "without paperwork."
    override val simTabDefaultSubhead = "Mittpass is built by a cafe owner for cafe owners. Schedule, check in staff, meet legal requirements, and log temperatures – all from your phone."

    override val simRoleServering = "Service"
    override val simRoleKok = "Kitchen"
    override val simDagensSchema = "Today's Schedule"
    override val simExtraStaffAddedText = "Extra shift published to staff!"
    override val simResetBtn = "Reset simulator"
    override val simInviteStaffBtn = "+ Invite extra staff"
    override val simSkatteverketLiggare = "Skatteverket Staff Register"
    override val simCheckedInStatus = "CHECKED IN: Johan Berg"
    override val simNotCheckedInStatus = "NOT CHECKED IN"
    override val simCheckedInDesc = "Checked in at: 14:15. The log is audit-proof."
    override val simNotCheckedInDesc = "Click the button below to check in as staff."
    override val simCheckOutBtn = "Check out"
    override val simCheckInBtn = "Check in"
    override val simHaccpTitle = "Self-monitoring (HACCP)"
    override val simKyl1Name = "Fridge 1 (Drinks)"
    override val simFrysName = "Freezer (Kitchen)"
    override val simAllTempsOk = "✓ All temperatures approved!"
    override val simTempsWarning = "Some temperatures out of range!"

    override val footerFunktioner = "Features"
    override val footerPriser = "Pricing"
    override val footerFaq = "FAQ"
    override val footerKontakt = "Contact"
    override val footerEmail = "Email"

    override val showcaseSubTabWeek = "Week"
    override val showcaseSubTabMonth = "Month"
    override val showcaseSubTabYear = "Year"
    override val showcaseSubTabFlow = "Flow"
}

object ArabicDictionary : Dictionary {
    override val appTitle = "Mittpass – مكان عملك"
    override val appSubtitle = "Mittpass – جدول ومسجل الموظفين للمقهى والمطعم"
    override val appDesc = "إدارة الموظفين للمقهى والبيتزا والمطعم. مسجل الموظفين الإلكتروني والجدولة والرقابة الذاتية."
    
    override val cookieNotice = "نستخدم ملفات تعريف الارتباط لفهم كيفية استخدام الزوار للموقع (جوجل أناليتكس). لا نستخدم ملفات تعريف الارتباط للإعلانات."
    override val readMorePolicy = "اقرأ المزيد في سياسة الخصوصية الخاصة بنا"
    override val decline = "رفض"
    override val accept = "قبول"
    
    override val personalliggare = "سجل الموظفين"
    override val schemalagga = "الجدولة"
    override val egenkontroll = "الرقابة الذاتية"
    override val priser = "الأسعار"
    override val faq = "الأسئلة الشائعة"
    override val login = "تسجيل الدخول"
    override val getStarted = "البدء"
    override val startFree30 = "ابدأ 30 يومًا مجانًا"
    
    override val allSmallPlaceNeeds = "كل ما يحتاجه مشروع صغير"
    override val builtByOwner = "تم بناؤه بواسطة صاحب مقهى – للمقاهي والبيتزا والمطاعم"
    override val ownerQuote = SwedishDictionary.ownerQuote
    override val simpleTransparent = "بسيط وشفاف"
    override val trialInfo = "30 يومًا مجانًا — لا يلزم وجود بطاقة ائتمان"
    override val krPerUser = "39 كرونة"
    override val perUserMonth = "/ مستخدم نشط / شهر"
    override val exVatInfo = "غير شامل ضريبة القيمة المضافة. المستخدمون غير النشطين مجانيون دائمًا."
    override val commonQuestions = "الأسئلة المتداولة"

    // Simulator
    override val simRealtimeOps = "العمليات في الوقت الفعلي"
    override val simScheduleAndShifts = "الجدول والنوبات"
    override val simActiveShiftsToday = "3 نوبات نشطة اليوم"
    override val simSkatteverketAuditProof = "سجل متوافق مع مصلحة الضرائب"
    override val simFoodSafetyTitle = "سلامة الأغذية"
    override val simHygieneRounds = "جولات النظافة ودرجات الحرارة"
    override val simClickTabsToTest = "انقر فوق علامات التبويب لاختبار الوظائف"

    // Features Section
    override val feature1Title = "الجدول وتسجيل الحضور"
    override val feature1Desc = "أنشئ نوبات عمل في دقائق. يسجل الموظفون حضورهم مباشرة في التطبيق - تعرف على من في الموقع في الوقت الفعلي."
    override val feature2Title = "سجل الموظفين"
    override val feature2Desc = "تلبية متطلبات مصلحة الضرائب تلقائياً. عرض يومي، لقطة شاشة، وتصدير CSV للتدقيق."
    override val feature3Title = "تقارير الرواتب"
    override val feature3Desc = "وافق على ساعات العمل المصدرة مباشرة إلى فورتنوكس. لا مزيد من حسابات الساعات اليدوية."
    override val feature4Title = "إشعارات فورية"
    override val feature4Desc = "إشعار الموظفين بالنوبات الشاغرة مباشرة على هواتفهم. نقرة واحدة للمطالبة بنوبة عمل - لا حاجة للمكالمات."

    // Quote & Stats Section
    override val uspCafePizzeria = "مقهى وبيتزا"
    override val uspStaffRegister = "سجل موظفين إلكتروني"
    override val uspNoHardware = "بدون أجهزة إضافية"
    override val uspFortnoxExport = "تصدير إلى فورتنوكس"
    override val uspPushNotifications = "إشعارات فورية"

    override val stat1Title = "تطبيق 1"
    override val stat1Desc = "الجدول وسجل الموظفين والرواتب - كل ذلك في مكان واحد"
    override val stat2Title = "0 كرونة"
    override val stat2Desc = "بدون رسوم تأسيس أو فترة التزام - جرب 30 يومًا مجانًا"
    override val stat3Title = "100%"
    override val stat3Desc = "تلبية المتطلبات القانونية - سجل الموظفين والرقابة الذاتية HACCP"

    // Pricing Section
    override val priceFeature1 = "الجدول وتسجيل الحضور في الوقت الفعلي"
    override val priceFeature2 = "سجل الموظفين الإلكتروني (Skatteverket)"
    override val priceFeature3 = "تقارير الرواتب مع الموافقة والتصدير إلى فورتنوكس"
    override val priceFeature4 = "إشعارات فورية للنوبات الشاغرة"
    override val priceFeature5 = "إدارة الغيابات والعمل الإضافي"
    override val priceFeature6 = "المستخدمون غير النشطين مجانيون دائمًا"
    override val priceFeature7 = "بدون رسوم تأسيس · بدون فترة التزام"

    // How It Works
    override val howItWorksTitle = "كيف يعمل Mittpass"
    override val howItWorksSub = "بسط العمليات اليومية من خلال تدفقات رقمية لتخطيط الموظفين وسلامة الأغذية."
    override val timelineTabStaff = "الموظفون والرواتب"
    override val timelineTabHaccp = "الرقابة الذاتية (HACCP)"
    override val timelineStaffStep1Title = "1. تخطيط الجدول"
    override val timelineStaffStep1Desc = "أنشئ وانشر نوبات العمل في ثوانٍ. تعرف فوراً على المتوافرين وتجنب تعارض المواعيد."
    override val timelineStaffStep2Title = "2. ملء النوبات فوراً"
    override val timelineStaffStep2Desc = "يتلقى الموظفون إشعارات فورية ويمكنهم حجز نوباتهم بنقرة واحدة. لا مكالمات هاتفية أو رسائل متأخرة."
    override val timelineStaffStep3Title = "3. تسجيل حضور تلقائي"
    override val timelineStaffStep3Desc = "يسجل الموظفون الدخول والخروج مباشرة في التطبيق في مكان العمل. يتبع النظام الساعات بدقة متناهية."
    override val timelineStaffStep4Title = "4. الرواتب وسجل الموظفين"
    override val timelineStaffStep4Desc = "احصل على وثائق رواتب جاهزة ومصادق عليها. وفي نفس الوقت يتم استيفاء جميع قواعد سجل الموظفين مصلحة الضرائب."
    override val timelineHaccpStep1Title = "1. تحديد المهام"
    override val timelineHaccpStep1Desc = "أنشئ قوائم مهام للتنظيف، درجات الحرارة، والرقابة الذاتية مباشرة في النظام."
    override val timelineHaccpStep2Title = "2. التنفيذ في التطبيق"
    override val timelineHaccpStep2Desc = "يقوم الموظفون بشطب المهام وتسجيل درجات الحرارة في هواتفهم أثناء النوبة."
    override val timelineHaccpStep3Title = "3. احصل على تنبيهات فوراً"
    override val timelineHaccpStep3Desc = "إذا أصبحت الثلاجة دافئة جداً أو تم تفويت روتين تنظيف، فستتلقى تنبيهاً على الفور."
    override val timelineHaccpStep4Title = "4. تقرير التفتيش"
    override val timelineHaccpStep4Desc = "قم بتصدير تقارير كاملة ومختومة بالوقت أثناء تفتيش إدارة الصحة."

    // Showcase
    override val showcaseTitle = "شاهد النظام في بيئة العمل"
    override val showcaseSub = "كل ما تحتاجه لإدارة المقهى أو المطعم الخاص بك - في نظام واحد."
    override val showcaseTabSchema = "الجدول"
    override val showcaseTabPersonal = "الموظفون"
    override val showcaseTabLiggare = "سجل الموظفين"
    override val showcaseTabLoner = "الرواتب"
    override val showcaseTabEgenkontroll = "الرقابة الذاتية"
    override val showcaseTabInspektion = "تقرير التفتيش"
    override val showcaseTabSemester = "الإجازات"
    override val showcaseTabFranvaro = "الغياب"

    // FAQ Section
    override val faq1Question = "هل يناسب Mittpass مقهاي الصغير أو مطعم البيتزا الخاص بي؟"
    override val faq1Answer = "نعم - تم بناؤه خصيصاً لأجلك. تم تصميم Mittpass للأماكن التي تضم ما بين 2 و20 موظفاً. لا ميزات غير ضرورية، لا حاجة لإعدادات طويلة. ابدأ في يوم واحد."
    override val faq2Question = "ما هو سجل الموظفين وهل أحتاج إليه؟"
    override val faq2Answer = "نعم، تتطلب مصلحة الضرائب السويدية من المطاعم والمقاهي الاحتفاظ بسجل موظفين إلكتروني. يقوم Mittpass بذلك تلقائياً - لا أوراق أو قوائم يدوية."
    override val faq3Question = "كيف يعمل نظام تقارير الرواتب؟"
    override val faq3Answer = "يسجل الموظفون الحضور والانصراف عبر التطبيق. في نهاية الشهر، توافق على الساعات وتصدرها مباشرة إلى فورتنوكس أو تنزلها كملف CSV."
    override val faq4Question = "هل أحتاج إلى شراء أجهزة؟"
    override val faq4Answer = "لا. يستخدم الموظفون والمدراء هواتفهم الذكية الخاصة. لا أجهزة لوحية، لا أجهزة تسجيل، ولا شيء لتثبيته في الموقع."
    override val faq5Question = "هل يمكنني التجربة قبل الشراء؟"
    override val faq5Answer = "نعم. تحصل على فترة تجريبية مجانية لمدة 30 يوماً دون إدخال بيانات البطاقة. اختبر جميع الميزات بالكامل - ثم قرر ما إذا كنت تريد الاستمرار."

    // Contact
    override val contactUs = "اتصل بنا"
    override val contactSub = "أسئلة، ملاحظات، أو دعم فني - نجيب خلال يوم عمل واحد."
    override val contactSuccess = "✓ شكراً لك! سنرد عليك في أقرب وقت ممكن."
    override val contactNamePlaceholder = "اسمك"
    override val contactEmailPlaceholder = "عنوان بريدك الإلكتروني"
    override val contactMessagePlaceholder = "رسالتك..."
    override val contactFillAllFields = "يرجى ملء جميع الحقول."
    override val contactGenericError = "حدث خطأ ما. يرجى المحاولة مرة أخرى أو مراسلتنا عبر البريد الإلكتروني مباشرة."
    override val contactSending = "جاري الإرسال..."
    override val contactSendBtn = "إرسال الرسالة"

    // Footer
    override val footerTagline = "إدارة الموظفين للمقهى، مطعم البيتزا، والمطعم - تم بناؤه بواسطة صاحب مقهى."
    override val footerProduct = "المنتج"
    override val footerAllRights = "© Mittpass. جميع الحقوق محفوظة."
    override val footerPrivacy = "سياسة الخصوصية"
    override val footerTerms = "شروط الخدمة"
    override val footerDpa = "اتفاقية معالجة البيانات"
    override val footerDeleteAccount = "حذف الحساب والبيانات"
    override val footerSupport = "الدعم والمساعدة"

    // Sign Up Section
    override val signUpTitle = "ابدأ خلال 30 ثانية"
    override val signUpSub = "أنشئ حساباً مجاناً واختبر جميع الميزات لمدة 30 يوماً. بدون بطاقة ائتمان، وبدون فترة التزام."
    override val signUpSuccessTitle = "تحقق من بريدك الإلكتروني!"
    override val signUpSuccessPrefix = "لقد أرسلنا بريداً إلكترونياً للتحقق إلى "
    override val signUpSuccessSuffix = ". انقر على الرابط لتنشيط حسابك."
    override val fieldNameOrgName = "اسم الشركة"
    override val fieldPlaceholderOrgName = "شركتك ش.م.م"
    override val fieldNameWorkplace = "مكان العمل"
    override val fieldPlaceholderWorkplace = "مثال: مطعم وسط المدينة"
    override val fieldNameEmail = "البريد الإلكتروني"
    override val fieldPlaceholderEmail = "you@email.com"
    override val fieldNamePassword = "كلمة المرور"
    override val fieldPlaceholderPassword = "8 أحرف على الأقل"
    override val signUpPasswordMinLen = "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل."
    override val signUpRegisterError = "فشل التسجيل."
    override val signUpCreatingAccount = "جاري إنشاء الحساب..."
    override val signUpCreateAccountBtn = "أنشئ حساباً مجانياً"
    override val signUpAlreadyHaveAccount = "هل لديك حساب بالفعل؟ سجل الدخول باستخدام الزر الموجود في أعلى الصفحة."

    // Founder Note
    override val founderNoteQuote = SwedishDictionary.founderNoteQuote
    override val founderName = SwedishDictionary.founderName
    override val founderTitle = SwedishDictionary.founderTitle

    // Analytics & Common
    override val loading = "جاري التحميل..."
    override val close = "إغلاق"
    override val noData = "لا توجد بيانات."

    // KPI Cards
    override val kpiStaff = "الموظفون"
    override val kpiCheckedIn = "المسجلون الآن"
    override val kpiWorkedHours = "ساعات العمل (30 يوم)"
    override val kpiApprovedPayroll = "ساعات العمل المعتمدة"
    override val kpiShiftsThisWeek = "نوبات هذا الأسبوع"
    override val kpiUnclaimedShifts = "نوبات غير محجوزة"
    override val kpiAbsencesToReview = "طلبات غياب للمراجعة"
    override val kpiActiveAbsences = "حالات الغياب النشطة اليوم"

    // Daily hours chart
    override val chartWorkedHoursTitle = "ساعات العمل يومياً (آخر 14 يوم)"

    // Modals
    override val modalStaffTitle = "الموظفون"
    override val modalStaffSub = "أشخاص"
    override val modalCheckedInTitle = "المسجلون الآن"
    override val modalCheckedInSub = "أشخاص"
    override val modalWorkedTitle = "ساعات العمل (30 يوم)"
    override val modalWorkedSub = "إجمالي"
    override val modalPayrollTitle = "ساعات العمل المعتمدة (30 يوم)"
    override val modalPayrollSub = "إجمالي"
    override val modalShiftsTitle = "نوبات هذا الأسبوع"
    override val modalShiftsSub = "نوبات"
    override val modalUnclaimedTitle = "نوبات غير محجوزة هذا الأسبوع"
    override val modalUnclaimedSub = "نوبات بدون موظفين"
    override val modalPendingAbsenceTitle = "طلبات غياب للمراجعة"
    override val modalPendingAbsenceSub = "طلبات قيد الانتظار"
    override val modalActiveAbsenceTitle = "حالات الغياب النشطة اليوم"
    override val modalActiveAbsenceSub = "أشخاص غائبون"

    // Status / Roles
    override val roleManager = "مدير"
    override val roleStaff = "موظف"
    override val statusCheckedInSince = "منذ"
    override val statusClaimed = "محجوزة"
    override val statusUnclaimed = "شاغرة"
    override val statusPending = "قيد الانتظار"

    // Empty States
    override val emptyCheckedIn = "لا أحد مسجل حضور الآن."
    override val emptyWorked = "لا توجد بيانات لآخر 30 يوم."
    override val emptyPayroll = "لا توجد ساعات عمل معتمدة."
    override val emptyShifts = "لا توجد نوبات هذا الأسبوع."
    override val emptyUnclaimed = "جميع النوبات محجوزة!"
    override val emptyPendingAbsence = "لا توجد طلبات غياب للمراجعة."
    override val emptyActiveAbsence = "لا توجد حالات غياب اليوم."

    // Absence Types
    override val absTypeSick = "مرض"
    override val absTypeVab = "رعاية طفل (VAB)"
    override val absTypeVacation = "إجازة"
    override val absTypeLeave = "إجازة غير مدفوعة"

    override val dayMon = "الإثنين"
    override val dayTue = "الثلاثاء"
    override val dayWed = "الأربعاء"
    override val dayThu = "الخميس"
    override val dayFri = "الجمعة"
    override val daySat = "السبت"
    override val daySun = "الأحد"

    override val back = "رجوع"
    override val email = "البريد الإلكتروني"
    override val password = "كلمة المرور"
    override val loggingIn = "جاري تسجيل الدخول…"
    override val dontHaveAccount = "ليس لديك حساب؟"
    override val alreadyHaveAccount = "لديك حساب بالفعل؟"
    override val register = "تسجيل"
    override val registerManagerSub = "سجل كمدير لمؤسسة جديدة"
    override val organization = "المؤسسة"
    override val workplace = "مكان العمل"
    override val min8Chars = "8 أحرف على الأقل"
    override val registerFailedEmailUsed = "تعذر إنشاء الحساب. قد يكون البريد الإلكتروني مستخدمًا بالفعل."

    override val signUpTermsPrefix = "بالتسجيل، فإنك توافق على "
    override val signUpTermsLink = "شروط الخدمة"
    override val signUpTermsMiddle = " وتدخل في "
    override val signUpTermsDpaLink = "اتفاقية معالجة البيانات"
    override val signUpTermsSuffix = " مع Mittpass."

    override val simTabHrEyebrow = "إدارة الموظفين"
    override val simTabHrHeadline1 = "أنشئ الجداول وإدارة تقارير الوقت "
    override val simTabHrHeadline2 = "بسرعة فائقة."
    override val simTabHrSubhead = "تخلص من جداول إكسل والجداول الورقية. خطط للنوبات، وأدر الإجازات، وأرسل تقارير الرواتب الجاهزة إلى Fortnox بنقرة بسيطة."

    override val simTabLiggareEyebrow = "سجل الموظفين"
    override val simTabLiggareHeadline1 = "سجل الموظفين الإلكتروني "
    override val simTabLiggareHeadline2 = "خالٍ تماماً من المتاعب."
    override val simTabLiggareSubhead = "لبّ المتطلبات القانونية بأمان. يسجل الموظفون الحضور والانصراف على هواتفهم في ثوانٍ. أنشئ تقارير واقية من التدقيق فوراً."

    override val simTabHaccpEyebrow = "سلامة الغذاء"
    override val simTabHaccpHeadline1 = "مراقبة الأغذية الرقمية و "
    override val simTabHaccpHeadline2 = "الرقابة الذاتية (HACCP)."
    override val simTabHaccpSubhead = "تجنب قوائم المراجعة المكتوبة بخط اليد والمجلدات. سجل درجات الحرارة، وقم بجولات النظافة، واحفظ كل شيء في السحابة – جاهز للمفتش."

    override val simTabDefaultEyebrow = "مقهى · بيتزا · مطعم"
    override val simTabDefaultHeadline1 = "أدر الجداول، وسجلات الموظفين، وسلامة الأغذية "
    override val simTabDefaultHeadline2 = "بدون معاملات ورقية."
    override val simTabDefaultSubhead = "تم بناء Mittpass بواسطة صاحب مقهى لأصحاب المقاهي. أدر الجدول، وسجل حضور الموظفين، واستوفِ المتطلبات القانونية، وسجل درجات الحرارة – كل ذلك من هاتفك."

    override val simRoleServering = "الخدمة"
    override val simRoleKok = "المطبخ"
    override val simDagensSchema = "جدول اليوم"
    override val simExtraStaffAddedText = "تم نشر نوبة إضافية للموظفين!"
    override val simResetBtn = "إعادة ضبط المحاكي"
    override val simInviteStaffBtn = "+ دعوة موظفين إضافيين"
    override val simSkatteverketLiggare = "سجل موظفي Skatteverket"
    override val simCheckedInStatus = "تم تسجيل الدخول: Johan Berg"
    override val simNotCheckedInStatus = "لم يتم تسجيل الدخول"
    override val simCheckedInDesc = "تم تسجيل الدخول في: 14:15. السجل محمي ضد التدقيق."
    override val simNotCheckedInDesc = "انقر فوق الزر أدناه لتسجيل الدخول في عرض الموظف."
    override val simCheckOutBtn = "تسجيل الخروج"
    override val simCheckInBtn = "تسجيل الدخول"
    override val simHaccpTitle = "الرقابة الذاتية (HACCP)"
    override val simKyl1Name = "ثلاجة 1 (مشروبات)"
    override val simFrysName = "فريزر (مطبخ)"
    override val simAllTempsOk = "✓ تمت الموافقة على جميع درجات الحرارة!"
    override val simTempsWarning = "بعض درجات الحرارة خارج النطاق المسموح به!"

    override val footerFunktioner = "الميزات"
    override val footerPriser = "الأسعار"
    override val footerFaq = "الأسئلة الشائعة"
    override val footerKontakt = "اتصل بنا"
    override val footerEmail = "البريد الإلكتروني"

    override val showcaseSubTabWeek = "أسبوع"
    override val showcaseSubTabMonth = "شهر"
    override val showcaseSubTabYear = "سنة"
    override val showcaseSubTabFlow = "تدفق"
}

object GermanDictionary : Dictionary {
    override val appTitle = "Mittpass – Ihr Arbeitsplatz"
    override val appSubtitle = "Mittpass – Dienstplan & Personalregister für Café und Restaurant"
    override val appDesc = "Personalverwaltung für Café, Pizzeria und Restaurant. Elektronisches Personalregister, Dienstplanung und Selbstkontrolle."
    
    override val cookieNotice = "Wir verwenden Cookies, um zu verstehen, wie Besucher die Website nutzen (Google Analytics). Es werden keine Werbecookies verwendet."
    override val readMorePolicy = "Mehr dazu in unserer Datenschutzerklärung"
    override val decline = "Ablehnen"
    override val accept = "Akzeptieren"
    
    override val personalliggare = "Personalregister"
    override val schemalagga = "Dienstplanung"
    override val egenkontroll = "Selbstkontrolle"
    override val priser = "Preise"
    override val faq = "FAQ"
    override val login = "Einloggen"
    override val getStarted = "Loslegen"
    override val startFree30 = "30 Tage kostenlos testen"
    
    override val allSmallPlaceNeeds = "Alles, was ein kleiner Betrieb braucht"
    override val builtByOwner = "Gebaut von einem Café-Besitzer – für Cafés, Pizzerien und Restaurants"
    override val ownerQuote = SwedishDictionary.ownerQuote
    override val simpleTransparent = "Einfach und transparent"
    override val trialInfo = "30 Tage kostenlos — keine Kreditkarte erforderlich"
    override val krPerUser = "39 kr"
    override val perUserMonth = "/ aktiver Nutzer / Monat"
    override val exVatInfo = "Zzgl. MwSt. Inaktive Nutzer sind immer kostenlos."
    override val commonQuestions = "Häufig gestellte Fragen"

    // Simulator
    override val simRealtimeOps = "Betrieb in Echtzeit"
    override val simScheduleAndShifts = "Dienstplan & Schichten"
    override val simActiveShiftsToday = "3 active Schichten heute"
    override val simSkatteverketAuditProof = "Finanzamt-sicher"
    override val simFoodSafetyTitle = "Lebensmittelkontrolle"
    override val simHygieneRounds = "Hygieneschulung & Temperaturen"
    override val simClickTabsToTest = "Klicken Sie auf die Tabs, um die Funktionen zu testen"

    // Features Section
    override val feature1Title = "Dienstplan & Check-ins"
    override val feature1Desc = "Erstellen Sie Schichten in Minuten. Mitarbeiter checken direkt in der App ein – Sie sehen in Echtzeit, wer da ist."
    override val feature2Title = "Personalregister"
    override val feature2Desc = "Gesetzliche Anforderungen automatisch erfüllt. Tagesansicht, Snapshot und CSV-Export für Prüfungen."
    override val feature3Title = "Lohnabrechnung"
    override val feature3Desc = "Genehmigen Sie Arbeitsstunden und exportieren Sie sie direkt zu Fortnox. Keine manuellen Stundenberechnungen."
    override val feature4Title = "Push-Benachrichtigungen"
    override val feature4Desc = "Offene Schichten werden direkt an die Mitarbeiter gesendet. Ein Klick zum Buchen – keine Anrufe nötig."

    // Quote & Stats Section
    override val uspCafePizzeria = "Café & Pizzeria"
    override val uspStaffRegister = "Elektronisches Personalregister"
    override val uspNoHardware = "Keine Hardware"
    override val uspFortnoxExport = "Fortnox-Export"
    override val uspPushNotifications = "Push-Benachrichtigungen"

    override val stat1Title = "1 App"
    override val stat1Desc = "Dienstplan, Personalregister & Lohnabrechnung – alles an einem Ort"
    override val stat2Title = "0 €"
    override val stat2Desc = "Keine Einrichtungsgebühr oder Laufzeit – 30 Tage kostenlos testen"
    override val stat3Title = "100%"
    override val stat3Desc = "Gesetzliche Anforderungen erfüllt – Personalregister & HACCP-Eigenkontrolle"

    // Pricing Section
    override val priceFeature1 = "Echtzeit-Dienstplan & Check-ins"
    override val priceFeature2 = "Elektronisches Personalregister (Skatteverket)"
    override val priceFeature3 = "Lohnabrechnung mit Genehmigung und Fortnox-Export"
    override val priceFeature4 = "Push-Benachrichtigungen für offene Schichten"
    override val priceFeature5 = "Abwesenheits- und Überstundenverwaltung"
    override val priceFeature6 = "Inaktive Nutzer sind immer kostenlos"
    override val priceFeature7 = "Keine Einrichtungsgebühr · Keine Mindestlaufzeit"

    // How It Works
    override val howItWorksTitle = "So funktioniert Mittpass"
    override val howItWorksSub = "Vereinfachen Sie den Alltag mit digitalen Abläufen für Personalplanung und Lebensmittelsicherheit."
    override val timelineTabStaff = "Personal & Lohn"
    override val timelineTabHaccp = "Selbstkontrolle (HACCP)"
    override val timelineStaffStep1Title = "1. Dienstplan erstellen"
    override val timelineStaffStep1Desc = "Erstellen und veröffentlichen Sie Schichten in Sekunden. Sehen Sie sofort, wer verfügbar ist."
    override val timelineStaffStep2Title = "2. Schichten sofort besetzen"
    override val timelineStaffStep2Desc = "Mitarbeiter erhalten Push-Meldungen und können Schichten mit einem Klick buchen. Keine Anrufe."
    override val timelineStaffStep3Title = "3. Automatisches Einchecken"
    override val timelineStaffStep3Desc = "Mitarbeiter stempeln direkt vor Ort in der App ein und aus. Das System erfasst die Stunden sekundengenau."
    override val timelineStaffStep4Title = "4. Lohn & Personalregister"
    override val timelineStaffStep4Desc = "Erhalten Sie fertige Lohnunterlagen genehmigt und bereit. Gleichzeitig werden alle Finanzamtsregeln erfüllt."
    override val timelineHaccpStep1Title = "1. Aufgaben definieren"
    override val timelineHaccpStep1Desc = "Erstellen Sie Checklisten für Reinigung, Temperaturen und Selbstkontrolle direkt im System."
    override val timelineHaccpStep2Title = "2. In der App ausführen"
    override val timelineHaccpStep2Desc = "Mitarbeiter haken Aufgaben ab und protokollieren Temperaturen während der Schicht im Handy."
    override val timelineHaccpStep3Title = "3. Sofort Alarme erhalten"
    override val timelineHaccpStep3Desc = "Wenn ein Kühlschrank zu warm wird oder eine Reinigung vergessen wird, erhalten Sie sofort eine Meldung."
    override val timelineHaccpStep4Title = "4. Inspektionsbericht"
    override val timelineHaccpStep4Desc = "Exportieren Sie vollständige, zeitgestempelte Berichte bei Kontrollen durch das Gesundheitsamt."

    // Showcase
    override val showcaseTitle = "Das System in Aktion sehen"
    override val showcaseSub = "Alles, was Sie für den Betrieb Ihres Cafés oder Restaurants benötigen – in einem einzigen System."
    override val showcaseTabSchema = "Dienstplan"
    override val showcaseTabPersonal = "Personal"
    override val showcaseTabLiggare = "Personalregister"
    override val showcaseTabLoner = "Löhne"
    override val showcaseTabEgenkontroll = "Selbstkontrolle"
    override val showcaseTabInspektion = "Inspektionsbericht"
    override val showcaseTabSemester = "Urlaub"
    override val showcaseTabFranvaro = "Abwesenheit"

    // FAQ Section
    override val faq1Question = "Passt Mittpass zu meinem kleinen Café oder meiner Pizzeria?"
    override val faq1Answer = "Ja – genau dafür ist es gebaut. Mittpass ist für Betriebe mit 2–20 Mitarbeitern konzipiert. Keine unnötigen Funktionen, schnelle Einrichtung in einem Tag."
    override val faq2Question = "Was ist ein Personalregister und muss ich eines führen?"
    override val faq2Answer = "Ja, das Skatteverket verlangt von Restaurants und Cafés ein elektronisches Personalregister. Mittpass erledigt dies automatisch."
    override val faq3Question = "Wie funktioniert die Lohnabrechnung?"
    override val faq3Answer = "Mitarbeiter checken über die App ein und aus. Am Monatsende genehmigen Sie die Stunden und exportieren direkt zu Fortnox oder als CSV."
    override val faq4Question = "Muss ich Hardware kaufen?"
    override val faq4Answer = "Nein. Mitarbeiter und Manager nutzen ihre eigenen Smartphones. Kein Tablet, kein Terminal vor Ort nötig."
    override val faq5Question = "Kann ich vor dem Kauf testen?"
    override val faq5Answer = "Ja. Sie erhalten eine 30-tägige kostenlose Testphase ohne Angabe von Kreditkartendaten. Testen Sie alle Funktionen."

    // Contact
    override val contactUs = "Kontaktieren Sie uns"
    override val contactSub = "Fragen, Feedback oder technischer Support — wir antworten innerhalb eines Werktages."
    override val contactSuccess = "✓ Vielen Dank! Wir werden uns so schnell wie möglich bei Ihnen melden."
    override val contactNamePlaceholder = "Ihr Name"
    override val contactEmailPlaceholder = "Ihre E-Mail-Adresse"
    override val contactMessagePlaceholder = "Ihre Nachricht..."
    override val contactFillAllFields = "Bitte füllen Sie alle Felder aus."
    override val contactGenericError = "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder mailen Sie uns direkt."
    override val contactSending = "Wird gesendet..."
    override val contactSendBtn = "Nachricht senden"

    // Footer
    override val footerTagline = "Personalverwaltung für Café, Pizzeria und Restaurant – gebaut von einem Café-Besitzer."
    override val footerProduct = "Produkt"
    override val footerAllRights = "© Mittpass. Alle Rechte vorbehalten."
    override val footerPrivacy = "Datenschutzerklärung"
    override val footerTerms = "Nutzungsbedingungen"
    override val footerDpa = "Auftragsverarbeitungsvereinbarung"
    override val footerDeleteAccount = "Konto & Daten löschen"
    override val footerSupport = "Support & Hilfe"

    // Sign Up Section
    override val signUpTitle = "In 30 Sekunden loslegen"
    override val signUpSub = "Erstellen Sie kostenlos ein Konto und testen Sie 30 Tage lang alle Funktionen. Keine Kreditkarte, keine Laufzeit."
    override val signUpSuccessTitle = "Prüfen Sie Ihr E-Mail-Postfach!"
    override val signUpSuccessPrefix = "Wir haben eine Bestätigungs-E-Mail gesendet an "
    override val signUpSuccessSuffix = ". Klicken Sie auf den Link, um Ihr Konto zu aktivieren."
    override val fieldNameOrgName = "Unternehmensname"
    override val fieldPlaceholderOrgName = "Ihr Unternehmen GmbH"
    override val fieldNameWorkplace = "Arbeitsort"
    override val fieldPlaceholderWorkplace = "Z.B. Restaurant Mitte"
    override val fieldNameEmail = "E-Mail"
    override val fieldPlaceholderEmail = "ihre@email.de"
    override val fieldNamePassword = "Passwort"
    override val fieldPlaceholderPassword = "Mindestens 8 Zeichen"
    override val signUpPasswordMinLen = "Das Passwort muss mindestens 8 Zeichen lang sein."
    override val signUpRegisterError = "Registrierung fehlgeschlagen."
    override val signUpCreatingAccount = "Konto wird erstellt..."
    override val signUpCreateAccountBtn = "Kostenlos registrieren"
    override val signUpAlreadyHaveAccount = "Haben Sie bereits ein Konto? Melden Sie sich über die Schaltfläche oben auf der Seite an."

    // Founder Note
    override val founderNoteQuote = SwedishDictionary.founderNoteQuote
    override val founderName = SwedishDictionary.founderName
    override val founderTitle = SwedishDictionary.founderTitle

    // Analytics & Common
    override val loading = "Laden..."
    override val close = "Schließen"
    override val noData = "Keine Daten."

    // KPI Cards
    override val kpiStaff = "Personal"
    override val kpiCheckedIn = "Eingestempelt"
    override val kpiWorkedHours = "Arbeitsstunden (30 Tage)"
    override val kpiApprovedPayroll = "Genehmigte Lohnstunden"
    override val kpiShiftsThisWeek = "Schichten diese Woche"
    override val kpiUnclaimedShifts = "Offene Schichten"
    override val kpiAbsencesToReview = "Abwesenheiten zu prüfen"
    override val kpiActiveAbsences = "Aktive Abwesenheiten heute"

    // Daily hours chart
    override val chartWorkedHoursTitle = "Arbeitsstunden pro Tag (letzte 14 Tage)"

    // Modals
    override val modalStaffTitle = "Personal"
    override val modalStaffSub = "Personen"
    override val modalCheckedInTitle = "Gerade eingestempelt"
    override val modalCheckedInSub = "Personen"
    override val modalWorkedTitle = "Arbeitsstunden (30 Tage)"
    override val modalWorkedSub = "gesamt"
    override val modalPayrollTitle = "Genehmigte Lohnstunden (30 Tage)"
    override val modalPayrollSub = "gesamt"
    override val modalShiftsTitle = "Schichten diese Woche"
    override val modalShiftsSub = "Schichten"
    override val modalUnclaimedTitle = "Offene Schichten diese Woche"
    override val modalUnclaimedSub = "Schichten ohne Personal"
    override val modalPendingAbsenceTitle = "Abwesenheiten zu prüfen"
    override val modalPendingAbsenceSub = "Anträge ausstehend"
    override val modalActiveAbsenceTitle = "Aktive Abwesenheiten heute"
    override val modalActiveAbsenceSub = "Personen abwesend"

    // Status / Roles
    override val roleManager = "Manager"
    override val roleStaff = "Personal"
    override val statusCheckedInSince = "Seit"
    override val statusClaimed = "Übernommen"
    override val statusUnclaimed = "Offen"
    override val statusPending = "Ausstehend"

    // Empty States
    override val emptyCheckedIn = "Niemand ist gerade eingestempelt."
    override val emptyWorked = "Keine Daten für die letzten 30 Tage."
    override val emptyPayroll = "Keine genehmigten Lohnstunden."
    override val emptyShifts = "Keine Schichten diese Woche."
    override val emptyUnclaimed = "Alle Schichten sind vergeben!"
    override val emptyPendingAbsence = "Keine Abwesenheitsanträge zu prüfen."
    override val emptyActiveAbsence = "Keine aktiven Abwesenheiten heute."

    // Absence Types
    override val absTypeSick = "Krank"
    override val absTypeVab = "Kind krank (VAB)"
    override val absTypeVacation = "Urlaub"
    override val absTypeLeave = "Freistellung"

    // Day Names Short
    override val dayMon = "Mo"
    override val dayTue = "Di"
    override val dayWed = "Mi"
    override val dayThu = "Do"
    override val dayFri = "Fr"
    override val daySat = "Sa"
    override val daySun = "So"

    override val back = "Zurück"
    override val email = "E-Mail"
    override val password = "Passwort"
    override val loggingIn = "Wird eingeloggt…"
    override val dontHaveAccount = "Haben Sie noch kein Konto?"
    override val alreadyHaveAccount = "Haben Sie bereits ein Konto?"
    override val register = "Registrieren"
    override val registerManagerSub = "Registrieren Sie sich als Manager für eine neue Organisation"
    override val organization = "Organisation"
    override val workplace = "Arbeitsplatz"
    override val min8Chars = "Mindestens 8 Zeichen"
    override val registerFailedEmailUsed = "Registrierung fehlgeschlagen. Die E-Mail-Adresse wird möglicherweise bereits verwendet."

    override val signUpTermsPrefix = "Mit der Registrierung stimmen Sie unseren "
    override val signUpTermsLink = "Nutzungsbedingungen"
    override val signUpTermsMiddle = " zu und gehen eine "
    override val signUpTermsDpaLink = "Auftragsverarbeitungsvereinbarung"
    override val signUpTermsSuffix = " mit Mittpass ein."

    override val simTabHrEyebrow = "Personalverwaltung"
    override val simTabHrHeadline1 = "Dienstpläne erstellen und Arbeitszeiten erfassen "
    override val simTabHrHeadline2 = "in Lichtgeschwindigkeit."
    override val simTabHrSubhead = "Schluss mit Excel-Tabellen und Papierzetteln. Schichten planen, Abwesenheiten verwalten und fertige Lohnunterlagen per Klick an Fortnox senden."

    override val simTabLiggareEyebrow = "Personalregister"
    override val simTabLiggareHeadline1 = "Elektronisches Personalregister "
    override val simTabLiggareHeadline2 = "völlig unkompliziert."
    override val simTabLiggareSubhead = "Gesetzliche Vorgaben sicher erfüllen. Mitarbeiter stempeln sich in Sekunden auf dem Smartphone ein und aus. Audit-sichere Berichte sofort generieren."

    override val simTabHaccpEyebrow = "Lebensmittelkontrolle"
    override val simTabHaccpHeadline1 = "Digitale Lebensmittelkontrolle und "
    override val simTabHaccpHeadline2 = "Selbstkontrolle (HACCP)."
    override val simTabHaccpSubhead = "Keine handschriftlichen Checklisten und Ordner mehr. Temperaturen erfassen, Hygiene-Rundgänge durchführen und alles in der Cloud speichern."

    override val simTabDefaultEyebrow = "Café · Pizzeria · Restaurant"
    override val simTabDefaultHeadline1 = "Dienstplan, Personalregister und Lebensmittelkontrolle steuern "
    override val simTabDefaultHeadline2 = "ohne Papierkram."
    override val simTabDefaultSubhead = "Mittpass wurde von einem Café-Besitzer für Café-Besitzer entwickelt. Dienstpläne verwalten, Personal einchecken, Gesetze einhalten und Temperaturen protokollieren."

    override val simRoleServering = "Service"
    override val simRoleKok = "Küche"
    override val simDagensSchema = "Heutiger Dienstplan"
    override val simExtraStaffAddedText = "Zusätzliche Schicht für Mitarbeiter veröffentlicht!"
    override val simResetBtn = "Simulator zurücksetzen"
    override val simInviteStaffBtn = "+ Zusätzliches Personal einladen"
    override val simSkatteverketLiggare = "Skatteverket Personalregister"
    override val simCheckedInStatus = "EINGESTEMPELT: Johan Berg"
    override val simNotCheckedInStatus = "NICHT EINGESTEMPELT"
    override val simCheckedInDesc = "Eingestempelt um: 14:15 Uhr. Das Register ist audit-sicher."
    override val simNotCheckedInDesc = "Klicken Sie auf die Schalfläche unten, um sich in der Mitarbeiteransicht einzustempeln."
    override val simCheckOutBtn = "Ausstempeln"
    override val simCheckInBtn = "Einstempeln"
    override val simHaccpTitle = "Selbstkontrolle (HACCP)"
    override val simKyl1Name = "Kühlschrank 1 (Getränke)"
    override val simFrysName = "Gefrierschrank (Küche)"
    override val simAllTempsOk = "✓ Alle Temperaturen im grünen Bereich!"
    override val simTempsWarning = "Einige Temperaturen liegen außerhalb der Grenzwerte!"

    override val footerFunktioner = "Funktionen"
    override val footerPriser = "Preise"
    override val footerFaq = "FAQ"
    override val footerKontakt = "Kontakt"
    override val footerEmail = "E-Mail"

    override val showcaseSubTabWeek = "Woche"
    override val showcaseSubTabMonth = "Monat"
    override val showcaseSubTabYear = "Jahr"
    override val showcaseSubTabFlow = "Fluss"
}
